export const CSV_DOWNLOAD_MAPS = [
    { field: 'mtPlanCell', fieldKey: 'tooltip' },
     {field: 'taskManager', fieldKey: 'fullName'}, 
     {field: 'directManager', fieldKey: 'fullName'},
     {field: 'createdByOrgUser', fieldKey: 'fullName'},
]